//@vendors
import moment from 'moment';
import Context from 'context/appContext'
import { useContext, useEffect, useState } from 'react'
import { filterObject, getValueField, validateForm, InsuredKeys, getDate, validateDiff } from 'utils/utils'
import { fields } from 'constants/fieldTypes';

//@components
import { Modal } from 'antd'

// @styles
import './styles.scss'

export default function InsuredCards({ info, current, form }) {
    const [isAdd, setIsAdd] = useState(false);
    const [activeFocus, setActiveFocus] = useState(false);
    const [editInsured, setEditInsured] = useState({});
    const [imgUrl, setImgUrl] = useState("");
    const [visibleAdd, setVisibleAdd] = useState(true);
    const { dataForm: { formResponses, disabledFields }, insureds, setInsureds } = useContext(Context);

    useEffect(() => {
        if (info) {
            const indexIns = insureds.findIndex(x => x.type === "T");
            const objInsured = getInsuredValue("T");
            if (indexIns !== -1) {
                insureds[indexIns] = {
                    ...insureds[indexIns],
                    img: objInsured.img,
                    gender: objInsured.gender,
                    age: objInsured.age
                };
            } else {
                setInsureds([...insureds, objInsured])
            }
        }
    }, []);

    // Cada que haya un cambio de estado para los asegurados -> se valida la cantidad y según el límite parametrizado, se oculta o no la funcionalidad de agregar asegurado
    useEffect(() => { setVisibleAdd(validateAmountInsureds({ amountInsureds: insureds.length })) }, [insureds]);

    useEffect(async () => {
        if (!form.isFieldsValidating()) {
            const activeFields = filterObject(form.getFieldsValue(), "Asegurado");
            if (await validateForm(Object.keys(activeFields), form) && validateDate(activeFields)) {
                setImgUrl(getImg(activeFields.fechaNacimientoAsegurado, activeFields.generoAsegurado));
                setEditInsured({ ...editInsured, img: '' });
            }
        }
    }, [form.isFieldsValidating()]);

    const validateActive = (insured) => {
        setActiveFocus(!insured && !editInsured.key ? false :
            (!insured && editInsured.key) || (insured && insured.key && (isAdd || editInsured.key)));
        return !isAdd && !editInsured.key;
    }

    const validateDate = (allFields) => {
        let validate = true;
        const key = "fechaNacimientoAsegurado";
        const dateField = info.components.find(x => x.key === key);
        if (dateField && dateField.properties && allFields && allFields.parentescoAsegurado) {
            const ranges = (dateField.properties[allFields.parentescoAsegurado])?.split("-");
            const insuredAge = getDate(allFields[key]);  // edad en años
            const insuredAgeInMs = Number(ranges[0]) == 0 ? moment().diff(moment(allFields[key], ["DD/MM/YYYY", "YYYY-MM-DD"]), 'seconds') : getDate(allFields[key]); //
            if ((Number(ranges[0]) === 0 && Number(ranges[1]) === 0) ? false : // si ambos lím inferior y superior son 0 -> se desactiva la regla
                (Number(ranges[0]) > insuredAgeInMs ||
                    Number(ranges[1]) < insuredAge ||
                    validateDiff(allFields.parentescoAsegurado, dateField, insureds, insuredAge))) {
                const messageError = dateField.validate ? dateField.validate.customMessage : "";
                form.setFields([{ name: key, errors: [messageError] }]);
                validate = false;
            }
        }
        return validate;
    };

    const getImg = (date, genderKey) => {
        const age = getDate(date);
        const images = info.components.find(x => x.key === "img");
        const labelImg = age < 18 ? InsuredKeys[1][genderKey] : InsuredKeys[0][genderKey];
        const img = images && images.values.find(z => z.label === labelImg);
        return img ? img : ''
    }

    const getInsuredValue = (kinship, date = "", genderKey = "") => {
        if (formResponses) {
            const newGenderKey = genderKey ? genderKey : getValueField("genero", formResponses);
            const newDate = date ? date : getValueField("fechaNacimiento", formResponses);
            const img = getImg(newDate, newGenderKey);
            return {
                key: moment().unix(),
                type: kinship,
                img: img?.value,
                gender: newGenderKey,
                age: newDate,
                label: img?.label
            };
        }
    }

    const addInsured = async () => {
        const fieldsValues = filterObject(form.getFieldsValue(), "Asegurado");
        const fieldsKeys = Object.keys(fieldsValues);
        if (await validateForm(fieldsKeys, form) && validateDate(fieldsValues)) {
            const newInsured = getInsuredValue(fieldsValues.parentescoAsegurado,
                fieldsValues.fechaNacimientoAsegurado, fieldsValues.generoAsegurado);
            const indexNewIns = editInsured && insureds.findIndex(x => x.key === editInsured.key);
            if (indexNewIns && indexNewIns !== -1) {
                insureds[indexNewIns] = newInsured;
                setInsureds([...insureds]);
                setEditInsured({});
            } else {
                setInsureds([...insureds, newInsured]);
            }
            form.resetFields(fieldsKeys);
            setImgUrl("");
            setIsAdd(false);
        }
    }

    const cleanFields = () => {
        const fieldsValues = filterObject(form.getFieldsValue(), "Asegurado");
        const fieldsKeys = Object.keys(fieldsValues);
        form.resetFields(fieldsKeys);
        setIsAdd(false);
        setEditInsured({});
        setImgUrl("");
        setVisibleAdd(validateAmountInsureds({ amountInsureds: insureds.length }));
    }

    const deleteInsured = (insured) => {
        disabledFields['parentescoAsegurado'] = insureds.length === 2 ? false : insured.type !== "C";
        const newInsureds = insureds && insureds.filter(z => z.key !== insured.key);
        setInsureds(newInsureds);
    }

    const getComponents = () => {
        const copyComponents = JSON.parse(JSON.stringify(info.components));
        validateInsured();
        copyComponents && copyComponents.forEach((component, index) => {
            const key = InsuredKeys[3][component.key];
            const value = key ? key !== 'age' ? editInsured[key] :
                moment(editInsured[key], ["DD/MM/YYYY", "YYYY-MM-DD"]).format('MM/DD/YYYY') : '';
            copyComponents[index].value = value;
        });
        return copyComponents;
    }

    const validateInsured = () => {
        const insuredC = insureds && insureds.find(ins => ins.type === "C");
        const insuredT = insureds && insureds.find(ins => ins.type === "T");
        const disabled = (insuredT && getDate(insuredT.age) < 18) ||
            (insuredC && insuredC.key !== editInsured.key);
        disabled && form.setFieldsValue({ ['parentescoAsegurado']: 'H' });
        disabledFields['parentescoAsegurado'] = disabled;
    }

    const onClickAddInsured = () => {
        setVisibleAdd(validateAmountInsureds({ amountInsureds: insureds.length + 1 }));
        validateActive(null) && setIsAdd(true);
        validateInsured();
    }

    const validateAmountInsureds = ({ amountInsureds }) => {
        const maxInsureds = info && info.properties && Number(info.properties.max);
        const validate = (!maxInsureds || maxInsureds == 0) ? true : amountInsureds < maxInsureds; //Si el max. asegurados es 0, entonces se desactiva la regla
        return validate;
    }

    const showModal = (insured) => {
        Modal.info({
            icon: '',
            title: 'Confirmación',
            className: 'modal-confirm',
            closable: true,
            okButtonProps: {
                className: 'ant-btn-solid c-2 ant-btn-size-xs'
            },
            okText: 'Confirmar',
            onclose: 'Cancelar',
            content: <p>¿Estás seguro que quieres eliminar al integrante seleccionado?</p>,
            onOk() { deleteInsured(insured) }
        });
    }

    const showFields = (components) => {
        return (
            <div className={`insured-cards-item insured-cards-item-info ${activeFocus ? 'shadow-error' : 'shadow'}`}>
                <div className='insured-cards-item-info-content'>
                    {components && components.map((field) => {
                        return field.key !== "img" ? fields(field.type, field, form, field.key, current) :
                            <div className='insured-cards-item-image'> {editInsured.img || imgUrl?.value ? <img src={editInsured.img || imgUrl?.value} alt={imgUrl?.label} /> : <em className='fas fa-user' />} </div>;
                    })}
                </div>
                <div className='insured-cards-item-info-actions'>
                    <div className='insured-cards-item-info-actions-item' onClick={() => cleanFields()}>
                        Cancelar
                    </div>
                    <div className='insured-cards-item-info-actions-item c-2' onClick={addInsured}>
                        Guardar
                    </div>

                </div>
            </div>
        )
    }

    const showIsured = (insured) => {
        return insured && (
            <> {insured.key === editInsured.key ? showFields(getComponents()) :
                <div className='insured-cards-item insured-cards-item-info'>
                    <div className='insured-cards-item-info-content'>
                        <div className='insured-cards-item-title'>
                            {InsuredKeys[2][insured.type]}
                        </div>
                        <div className='insured-cards-item-image'>
                            <img src={insured.img} alt={insured?.label} />
                        </div>
                        <div className='insured-cards-item-genere'>
                            <span>Género</span>
                            <strong>{InsuredKeys[0][insured.gender]}</strong>
                        </div>
                        <div className='insured-cards-item-age'>
                            <strong>{getDate(insured.age)}</strong>
                            <span>Años</span>
                        </div>
                    </div>
                    {insured.type !== "T" && (<div className='insured-cards-item-info-actions'>
                        <div
                            className='insured-cards-item-info-actions-item'
                            data-testid="edit"
                            onClick={() => validateActive(insured) && setEditInsured(insured)}
                        >
                            <em className='fal fa-pencil' />
                        </div>
                        <div className='insured-cards-item-info-actions-item'
                            data-testid="delete"
                            onClick={() => validateActive(insured) && showModal(insured)}>
                            <em className='fal fa-trash-alt' />
                        </div>
                    </div>)}
                </div>}
            </>
        )
    }

    return (
        <div className="insured-cards">
            {insureds && insureds.length > 0 && insureds.map((item) => showIsured(item))}
            {isAdd && showFields(info.components)}
            {visibleAdd && (<div className='insured-cards-item insured-cards-item-add' onClick={onClickAddInsured} >
                <em className='fal fa-plus' />
                <h3 className='insured-cards-item-add-title'>
                    Agregar asegurado
                </h3>
            </div>)}
        </div>
    )
}